var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-272.73 -396.254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.669,422.912c.036-.548.061-1.1.061-1.658s-.026-1.135-.064-1.7a25.024,25.024,0,0,0-24.271-23.286c-.221-.006-.442-.017-.665-.017-.256,0-.509.012-.764.019a25.028,25.028,0,0,0-24.2,23.695q-.033.639-.033,1.286t.033,1.286a25,25,0,0,0,49.906.372ZM297.73,442.254a21,21,0,1,1,21-21A21.024,21.024,0,0,1,297.73,442.254Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.221,
    height: 16.107,
    transform: "translate(296.119 409.466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.73,428.746a2.148,2.148,0,1,0,2.148,2.148A2.148,2.148,0,0,0,297.73,428.746Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.88cbba3e7d45d1561474cbf9af0f82c1.svg";
export { ForwardRef as ReactComponent };